import FirebaseAccountDetails from '../ui/FirebaseAccountDetails';
import { connect } from 'react-redux';
import { registerUser, backToAddress, nextPage, registerFirebaseUser } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    content: state.content,
    territory: state.territory,
    marketing_referrers: state.territory.host_marketing_referrers,
    marital_statuses: state.territory.marital_statuses,
    country_code: state.territory.country_code,
    environment: state.environment,
    transaction_email: state.territory.transaction_email,
    territory_code: state.territory.code,
    generateDetailsEnabled: state.territory.generate_details_enabled,
    showGenderField: state.territory.show_host_gender_field,
    criticalContracts: state.territory.host_critical_contracts,
    requiredFields: state.requiredFields,
    address: state.address,
    addressValidations: state.addressValidations,
    recaptchaSiteId: state.recaptchaSiteId,
    enable_firebase_authentication: state.territory.enable_firebase_authentication,
    email: props.email,
    password: props.password,
    authenticatedUser: state.authenticatedUser,
    hideRecaptcha: state.territory.hide_recaptcha
  });

const mapDispatchToProps = dispatch =>
  ({
    onRegisterUser(payload) {
      dispatch(
        registerUser(payload)
      );
    },
    onRegisterFirebaseUser(payload) {
      dispatch(
        registerFirebaseUser(payload)
      );
    },
    onGoBack(){
      dispatch(backToAddress())
    },
    onNext(){
      dispatch(
        nextPage(payload)
      )
    }
    
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(FirebaseAccountDetails);

export default Container;
